<template>
  <div class="vehicle-dropdown-container">
    <button v-if="!showSelectButton" class="vehicle-dropdown-container__information">
      <oie-use-svg svg="circle-information"></oie-use-svg>
    </button>

    <button v-if="showSelectButton" class="vehicle-dropdown-container__select">
      {{ tStatic('chooseFavoriteVehicle') }}
    </button>

    <div class="vehicle-dropdown">
      <button class="vehicle-dropdown__action-button vehicle-dropdown__action-button--toggler" :class="{ 'vehicle-dropdown__action-button--toggler-is-open': isOpen }" @click="toggleVehicleAccordion()">
        John Deere 1020
      </button>

      <ul class="vehicle-dropdown__content" :class="{ 'vehicle-dropdown__content--is-open': isOpen }">
        <li class="vehicle-dropdown__item vehicle-dropdown__item--no-select">
          <div class="vehicle-dropdown__action-button">
            {{ tStatic('titleFavoriteVehicle') }}
          </div>
        </li>

        <template v-for="(vehicle, i) of vehicles">
          <li v-if="i < 3 || i > 2 && !isFavoriteHidden" :key="`favorite-vehicle-${vehicle.name}`" class="vehicle-dropdown__item">
            <button class="vehicle-dropdown__favorite-toggler">
              <oie-use-svg svg="star-outline" color="#9d6917"></oie-use-svg>
            </button>

            <button class="vehicle-dropdown__action-button" @click="selectVehicle(i)">
              {{ vehicle.name }}

              <oie-use-svg
                v-if="selectedVehicle === i"
                svg="circle-check"
                css-classes="vehicle-dropdown__action-check-icon"
                :class="{ 'vehicle-dropdown__action-check-icon--edit-mode': editMode }"></oie-use-svg>
            </button>

            <button class="vehicle-dropdown__remove-action" :class="{ 'vehicle-dropdown__remove-action--edit-mode': editMode }">
              <oie-use-svg svg="close"></oie-use-svg>
            </button>
          </li>
        </template>

        <li v-if="vehicles.length > 4" class="vehicle-dropdown__item">
          <button class="vehicle-dropdown__action-button" @click="toggleFavoriteVehicles()">
            <template v-if="isFavoriteHidden">
              <oie-use-svg svg="expand-circle" css-classes="vehicle-dropdown__action-prefix-icon"></oie-use-svg>
              {{ tStatic('showMoreLink') }}
            </template>

            <template v-if="!isFavoriteHidden">
              <oie-use-svg svg="desmiss-circle" css-classes="vehicle-dropdown__action-prefix-icon"></oie-use-svg>
              {{ tStatic('closeLink') }}
            </template>
          </button>
        </li>

        <li class="vehicle-dropdown__item vehicle-dropdown__item--no-select">
          <div class="vehicle-dropdown__action-button">
            {{ tStatic('titleLatestVisits') }}
          </div>
        </li>

        <template v-for="(vehicle, i) of vehicles">
          <li v-if="i < 3" :key="`visited-vehicles-${vehicle.name}`" class="vehicle-dropdown__item">
            <button class="vehicle-dropdown__favorite-toggler">
              <oie-use-svg svg="star-outline" color="#9d6917"></oie-use-svg>
            </button>

            <button class="vehicle-dropdown__action-button">
              {{ vehicle.name }}

              <oie-use-svg v-if="selectedVehicle === i" svg="circle-check" css-classes="vehicle-dropdown__action-check-icon"></oie-use-svg>
            </button>
          </li>
        </template>

        <li class="vehicle-dropdown__item vehicle-dropdown__item--other-action">
          <a href="/" class="vehicle-dropdown__action-button vehicle-dropdown__action-button--link">
            {{ tStatic('titleAddMachine') }}
          </a>
        </li>

        <li class="vehicle-dropdown__item vehicle-dropdown__item--other-action">
          <button class="vehicle-dropdown__action-button vehicle-dropdown__action-button--edit" @click="toggleEditMode()">
            <template v-if="!editMode">
              <oie-use-svg svg="pen" css-classes="vehicle-dropdown__action-prefix-icon"></oie-use-svg>
              {{ tStatic('titleEditFavorite') }}
            </template>

            <template v-if="editMode">
              <oie-use-svg v-if="editMode" svg="close" css-classes="vehicle-dropdown__action-prefix-icon"></oie-use-svg>
              {{ tStatic('titleCloseEditFavorite') }}
            </template>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import accordion from '@/mixins/accordion.js'

export default {
  mixins: [accordion],
  props: {
    showSelectButton: {
      type: Boolean,
      default: false
    },
    vehicles: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    isFavoriteHidden: true,
    editMode: false,
    selectedVehicle: 0
  }),
  mounted() {
    for (let i = 0; i < 7; i++) {
      this.vehicles.push({
        id: i,
        name: `John Deere 10${i}0`
      })
    }
  },
  methods: {
    toggleFavoriteVehicles() {
      this.isFavoriteHidden = !this.isFavoriteHidden
    },
    toggleEditMode() {
      this.editMode = !this.editMode
    },
    selectVehicle(id) {
      this.selectedVehicle = id
    },
    resetDropdown() {
      this.isFavoriteHidden = true
      this.editMode = false
      this.selectedVehicle = 0
    },
    toggleVehicleAccordion() {
      this.toggleAccordion()
      this.resetDropdown()
    }
  }
}
</script>

<style lang="scss">
.vehicle-dropdown-container {
  display: flex;
  align-items: center;
}

.vehicle-dropdown-container > a {
  margin-left: measure(half);
}

.vehicle-dropdown-container__information {
  @include reset-button;
}

.vehicle-dropdown-container__select {
  @include reset-button;
  height: 2.5rem;
  background-color: color(background-blue-1);
  color: color(text-inverted);
  border-radius: other(border-radius);
  padding: 0 measure(quarter);

  &:hover {
    background-color: color(background-blue);
  }
}

.vehicle-dropdown {
  position: relative;
  width: 19.375rem;
  margin-left: measure(quarter);
  border: 2px solid color(border-blue-1);
  z-index: 2;
}

.vehicle-dropdown__content {
  position: absolute;
  top: 100%;
  right: -2px;
  left: -2px;
  display: none;
  list-style-type: none;
  margin: 2px 0 0 0;
  padding: 0;
  background-color: color(background-white);
  border: 2px solid color(border-blue-1);
  border-top: 0;
  z-index: 1;
}

.vehicle-dropdown__content--is-open {
  display: block;
}

.vehicle-dropdown__item {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0;
  background-color: color(background-blue-5);
  overflow: hidden;

  &:hover:not(.vehicle-dropdown__item--no-select) {
    background-color: color(background-blue-4);
  }
}

.vehicle-dropdown__item--other-action {
  background-color: color(background-blue-6);
}

.vehicle-dropdown__content > .vehicle-dropdown__item:not(:last-child) {
  border-bottom: 2px solid color(border-blue-1);
}

.vehicle-dropdown__action-button {
  @include reset-button;
  @include body-semi-bold;
  position: relative;
  flex-grow: 1;
  height: 3.125rem;
  padding: 0 measure(quarter) 0 measure(half);
}

.vehicle-dropdown__item--no-select .vehicle-dropdown__action-button:hover {
  cursor: initial;
}

.vehicle-dropdown__action-button--toggler {
  width: 100%;
  background-color: color(background-blue-5);

  &:after {
    content: "";
    position: absolute;
    top: 50%;
    right: 0.625rem;
    background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.875 6.147L12.064.093l1.294 1.25-6.483 7.564L.397 1.348 1.692.098z' fill='%230088C8' fill-rule='nonzero'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: contain;
    width: 0.875rem;
    height: 0.5625rem;
    transform: translateY(-50%);
  }
}

.vehicle-dropdown__action-button--toggler-is-open:after {
  transform: translateY(-50%) scale(-1);
}

.vehicle-dropdown__action-button--link {
  text-decoration: none;
  background-color: color(background-blue-6);
  color: color(text-blue);

  &:hover {
    text-decoration: underline;
  }

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    right: measure(quarter);
    width: 0.75rem;
    height: 1.3125rem;
    background-image: url("data:image/svg+xml,%3Csvg width='16' height='23' viewBox='0 0 16 23' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M10.66 11.894L.88 3 2.9.78l12.22 11.114L2.908 23 .89 20.78z' fill='currentColor' fill-rule='nonzero'/%3E%3C/svg%3E");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    transform: translateY(-50%);
    pointer-events: none;
  }
}

.vehicle-dropdown__action-button--edit {
  color: color(text-blue);
}

.vehicle-dropdown__action-prefix-icon {
  margin-right: measure(quarter);
  width: 1.25rem;
  height: 1.25rem;
}

.vehicle-dropdown__action-check-icon {
  position: relative;
  margin-left: auto;
  transform: translateX(0);
  transition: transform 200ms;
}

.vehicle-dropdown__action-check-icon--edit-mode {
  transform: translateX(-#{measure(full)});
}

.vehicle-dropdown__remove-action {
  @include reset-button;
  position: absolute;
  top: 50%;
  right: measure(quarter);
  width: 1.25rem;
  height: 1.25rem;
  margin-left: auto;
  transform: translateY(-50%) translateX(#{measure(full)});
  transition: transform 200ms;
}

.vehicle-dropdown__remove-action--edit-mode {
  transform: translateY(-50%) translateX(0);
}

.vehicle-dropdown__remove-action > svg {
  width: 100%;
  height: 100%;
}

.vehicle-dropdown__favorite-toggler {
  @include reset-button;
  height: 3.125rem;
  padding: 0 measure(half);
}

.vehicle-dropdown__favorite-toggler > svg {
  width: 100%;
  height: 100%;
}

.vehicle-dropdown__favorite-toggler + .vehicle-dropdown__action-button {
  padding-left: 0;
}
</style>
